import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';
import { compose, lifecycle } from 'recompose';

import PageLayout from '../../layouts/PageLayout';
import SplitLayout from '../../layouts/SplitLayout';

import JobReviewingInbox from './containers/JobInbox';
import JobReviewPanel from './containers/JobReviewPanel';
import { getUserDefaultDepartmentId, getUserDefaultDistrictId } from '../authentication/selectors';
import { selectDepartmentId, selectDistrictId, selectJobId } from './actions';
import { routerProps } from '../../propTypes';

const propTypes = exact({
  districtId: PropTypes.number.isRequired,
  departmentId: PropTypes.number.isRequired,
  setDistrictIdAction: PropTypes.func.isRequired,
  setDepartmentIdAction: PropTypes.func.isRequired,
  setJobIdAction: PropTypes.func.isRequired,
  ...routerProps,
});


const FieldAdminReviewPage = (props) => {
  return (
    <PageLayout
      title="Job Review"
      render={() => {
        return (
          <SplitLayout
            leftSize={3}
            leftRender={() => { return <JobReviewingInbox />; }}
            rightSize={9}
            rightRender={() => { return <JobReviewPanel />; }}
          />
        );
      }}
    />
  );
};


FieldAdminReviewPage.propTypes = propTypes;

const mapStateToProps = (state) => {
  return {
    districtId: getUserDefaultDistrictId(state),
    departmentId: getUserDefaultDepartmentId(state),
  };
};

const mapDispatchToProps = {
  setDistrictIdAction: selectDistrictId,
  setDepartmentIdAction: selectDepartmentId,
  setJobIdAction: selectJobId,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

const withInitPage = lifecycle({
  componentWillMount() {
    const {
      districtId,
      departmentId,
      setDistrictIdAction,
      setDepartmentIdAction,
      setJobIdAction,
    } = this.props;

    setJobIdAction(null);

    if (districtId) {
      setDistrictIdAction(districtId);
    }
    if (departmentId) {
      setDepartmentIdAction(departmentId);
    }
  },
});

const enhance = compose(
  withRedux,
  withInitPage,
);


export default enhance(FieldAdminReviewPage);
